import { ModelApi } from '@/services/api/modelApi'

export class CustomerEndpoints<T> extends ModelApi<T> {
  constructor(urlPath: string) {
    super(urlPath)
  }
}
